module.exports = __webpack_public_path__ + "static/media/polytechnic-campus.ce7f2c29.jp2";